import angular from 'angular';
import SecurityComponent from 'security/components/security/security-component';
import SecurityQuestionsComponent from 'security/components/security-questions/security-questions-component';

export default angular
  .module('security', ['rw-captcha'])
  .component('security', new SecurityComponent())
  .component('securityQuestions', new SecurityQuestionsComponent());



// WEBPACK FOOTER //
// ./src/modules/security/security-module.js